import React, {Component} from 'react';
import moment from 'moment';
import Main from '../Main';
import { path_create_user } from '../../routes/Pathnames';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {setLoadingGetUsers, getUsers, getUsersSuccess, getUsersError,
    setLoadingDeactivateUser, deactivateUser, deactivateUserSuccess, deactivateUserError, 
    setLoadingActivateUser, activateUser, activateUserSuccess, activateUserError} from '../../actions/UserActions';
import {TRANSLATE_YES, TRANSLATE_NO, TRANSLATE_LIST_OF_USERS, TRANSLATE_ADD_NEW_USER, TRANSLATE_ID, TRANSLATE_NAME, TRANSLATE_EMAIL, 
    TRANSLATE_PHONE, TRANSLATE_ROLE, TRANSLATE_CREATED, TRANSLATE_ACTIVE, TRANSLATE_QUESTION_DEACTIVATE_USER, 
    TRANSLATE_QUESTION_ACTIVATE_USER} from '../../translates/Translates';

class ListUsers extends Component{
    constructor(props){
        super(props);

        this.state = {
            users: []
        }
    }

    componentDidMount = () => {
        this.props.setLoadingGetUsers();
        this.props.getUsers().then((response) => {
            this.setState({users: response.payload.data});
            this.props.getUsersSuccess();
        }).catch(() => {
            this.props.getUsersError();
        })
    }

    geContentUserRole = (role) => {
        if(role.id === 1){
            return(<span className="badge badge-warning">{role.name}</span>);
        }else if(role.id === 2){
            return(<span className="badge badge-success">{role.name}</span>);
        }else if(role.id === 3){
            return(<span className="badge badge-danger">{role.name}</span>);
        }else if(role.id === 4){
            return(<span className="badge badge-info">{role.name}</span>);
        }
    }

    handleClickDeactivateUser = (id) => {
        if(window.confirm(TRANSLATE_QUESTION_DEACTIVATE_USER)){
            this.props.setLoadingDeactivateUser();
            this.props.deactivateUser(id)
            .then(() => {
                this.props.deactivateUserSuccess();
            }).catch(() => {
                this.props.deactivateUserError();
            })
        }
    }

    handleClickActivateUser = (id) => {
        if(window.confirm(TRANSLATE_QUESTION_ACTIVATE_USER)){   
            this.props.setLoadingActivateUser();
            this.props.activateUser(id)
            .then(() => {
                this.props.activateUserSuccess();
            }).catch(() => {
                this.props.activateUserError();
            })
        }
    }

    render(){
        console.log(this.state.user);
        return(
            <div>
                <Main/>
                <div className="page-wrapper">
                    <div className="container-fluid">
                        <br />
                        <div className="row page-tier3">
                            <div className="col s12">
                                <div className="card card-outline-info">
                                    <div className="card-header">
                                        <h4 className="mb-0 text-white">{TRANSLATE_LIST_OF_USERS}</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            {this.props.loadingGetRoles ? (
                                                <table id="demo-foo-addrow" className="table mt-4 table-hover no-wrap contact-list">
                                                    <tbody>
                                                        <tr className="preloader-tr">
                                                            <td colSpan="12" className="preloader">
                                                                <svg className="circular" viewBox="25 25 50 50">
                                                                    <circle className="path" cx="50" cy="50" r="20" fill="none" />
                                                                </svg>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="2">
                                                                <br/>
                                                                <Link to={path_create_user} className="btn btn-info btn-rounded" data-toggle="modal" data-target="#add-contact">{TRANSLATE_ADD_NEW_USER}</Link>
                                                            </td>
                                                            <td colSpan="10"></td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            ) : (
                                                <table id="demo-foo-addrow" className="table mt-4 table-hover no-wrap contact-list">
                                                    <thead>
                                                        <tr>
                                                            <th></th> 
                                                            <th>{TRANSLATE_ID}</th>
                                                            <th>{TRANSLATE_NAME}</th>
                                                            <th>{TRANSLATE_EMAIL}</th>
                                                            <th>{TRANSLATE_PHONE}</th>
                                                            <th>{TRANSLATE_ROLE}</th>
                                                            <th>{TRANSLATE_ACTIVE}</th>
                                                            <th>{TRANSLATE_CREATED}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.users.map((user, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td className="list-users-delete-td">
                                                                        {user.active ? (
                                                                            <button type="button" onClick={() => this.handleClickDeactivateUser(user.id)} className="list-users-delete-button">
                                                                                <i className="ti-close-td fas fa-times"></i>
                                                                            </button>
                                                                        ): (
                                                                            <button type="button" onClick={() => this.handleClickActivateUser(user.id)} className="list-users-delete-button">
                                                                                <i className="ti-check-td fas fa-check"></i>
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                    <td>{user.id}</td>
                                                                    <td>
                                                                        <Link to={'/edit-user/' + user.id}><img src={"/images/" + user.source} alt="user" className="rounded-circle" /> {user.name + " " + user.surname}</Link>
                                                                    </td>
                                                                    <td>{user.email}</td>
                                                                    <td>{user.phone}</td>
                                                                    <td>{this.geContentUserRole(user.role)}</td>
                                                                    <td>{user.active ? (<span className="badge badge-success">{TRANSLATE_YES}</span>) : (<span className="badge badge-danger">{TRANSLATE_NO}</span>)}</td>
                                                                    <td>{moment.unix(user.created).format("DD.MM.YYYY")}</td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="2">
                                                                <br/>
                                                                <Link to={path_create_user} className="btn btn-info btn-rounded" data-toggle="modal" data-target="#add-contact">{TRANSLATE_ADD_NEW_USER}</Link>
                                                            </td>
                                                            <td colSpan="10"></td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setLoadingGetUsers,
        getUsers,
        getUsersSuccess,
        getUsersError,
        setLoadingDeactivateUser,
        deactivateUser,
        deactivateUserSuccess,
        deactivateUserError,
        setLoadingActivateUser,
        activateUser,
        activateUserSuccess,
        activateUserError
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(ListUsers);
